import { httpGet, httpPost } from '../../../../../../utils/api.utils';
import { getRequestUserSessionData as getUserData } from '../../../../../../utils/helpers.utils';

import { actions } from 'react-redux-form';
import {
    //model
    wirelineTerminateModelB
    //action
    , setSubscriptionDetails
    , setFormSubmitted
} from './../../../../../../constants/model-reducers/external/request/wireline-request/wireline-terminate/wireline-terminate-exhibit-b.settings';

export const terminateCircuitModelBInitialState = wirelineTerminateModelB;

const defaultState = () => ({
    subscription: {}
    , formSubmitted: false
});

const initialState = defaultState();

export const wirelineTerminateExhibitBActions = {
    onSubscriptionSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineTerminateCircuitFormB } = state().form;

        if (value === '') {
            resetForm(dispatch);
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
            var obj = objects.find(o => o[propsName] === value);
            if (obj != null && obj.CircuitId != wirelineTerminateCircuitFormB.circuitId) {
                resetForm(dispatch);
                dispatch(actions.change('wirelineTerminateCircuitFormB.circuitCode', value));
                dispatch(actions.change('wirelineTerminateCircuitFormB.circuitId', obj.CircuitId));
                dispatch({ type: setSubscriptionDetails, data: obj });
            }
        }
    }
    , submitRequest: (date) => async (dispatch, state) => {

        const { wirelineTerminateCircuitFormB } = state().form;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;

        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
        }

        var data = {
            ...userData
            , requestTypeId: requestTypeId
            , wirelineTerminateRequest: {
                ...wirelineTerminateCircuitFormB
                , requestInBehalfId: userData.requestInBehalfId
                , terminateDate: date
            }
        }

        dispatch({ type: setFormSubmitted, data: true });
        var res = await httpPost('external/wirelineOrderRequest', data);

        dispatch({ type: setFormSubmitted, data: false });
        if (res || res.Success) {
            resetForm(dispatch);
            return res;
        }
    }
    , resetWirelineTerminateExhibitBForm: () => (dispatch) => {
        resetForm(dispatch);
    }
}

function resetForm(dispatch) {
    dispatch(actions.reset('wirelineTerminateCircuitFormB'));
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };

        default: return state;
    }
}